// Правилата за номер (име) на маса — общи за редактора на схемата и за
// страницата „Конфигурация на маси". Номерът Е името на масата в Маркиране
// (`bills.name`), затова BE го пази уникален без значение от регистъра.

import type { SchemaElement, SchemaRegion } from "../../api/restaurantSchema";

/**
 * Име на маса, завършващо на „*" — отказва се (BE 422): звездата е запазена за
 * офлайн режима (replay прави „2" → „2*" при заето име, а резервациите и
 * заетостта сравняват масите без нея). Съществуващите маси не се мигрират.
 */
export const hasTrailingStar = (name: string) => name.trim().endsWith("*");

/** Следващото свободно име на маса: най-големият цифров номер във всички региони + 1. */
export const nextTableName = (regions: SchemaRegion[]) => {
  const numbers = regions
    .flatMap((region) => region.elements)
    .filter((element) => element.kind === "table" && /^\d+$/.test(element.name ?? ""))
    .map((element) => Number(element.name));
  return String(numbers.length ? Math.max(...numbers) + 1 : 1);
};

/** Ключът, по който BE сравнява номерата: без интервали в краищата, без регистър. */
export const tableNameKey = (name: string) => name.trim().toLocaleLowerCase();

/** Номерът е зает от ДРУГА маса (във всеки регион) — BE би върнал 409. */
export const isTableNameTaken = (
  regions: SchemaRegion[],
  name: string,
  exceptId?: number,
) => {
  const key = tableNameKey(name);
  return regions.some((region) =>
    region.elements.some(
      (element) =>
        element.kind === "table" &&
        element.id !== exceptId &&
        tableNameKey(element.name ?? "") === key,
    ),
  );
};

/** Естествен ред по номер: „2" преди „10", „Бар 2" преди „Бар 10". */
export const compareTableNames = (left: SchemaElement, right: SchemaElement) =>
  (left.name ?? "").localeCompare(right.name ?? "", undefined, {
    numeric: true,
    sensitivity: "base",
  }) || left.id - right.id;
